import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "main" }

import store from "@/store";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  mobileHeader,
  footerMenu,
  mobileMenu,
  fullLoading,
} from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
}

const headerHeight = "4rem";
const footerHeight = "4.5rem";

export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  props: {
    accountId: {},
    menuList: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v7779b84a": (headerHeight),
  "v2619f469": (footerHeight)
}))

const { t } = useI18n();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(mobileHeader), {
        height: headerHeight,
        background: "#1C4736"
      }),
      _createElementVNode("main", _hoisted_3, [
        _renderSlot(_ctx.$slots, "main")
      ]),
      _createVNode(_unref(footerMenu), {
        "menu-list": __props.menuList,
        height: footerHeight,
        background: "#1C4736"
      }, null, 8, ["menu-list"])
    ]),
    (_unref(store).getters.loading)
      ? (_openBlock(), _createBlock(_unref(fullLoading), { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})